const s = "propify-units-list", a = (t) => `${s}-${t}`, i = "propify-unit-details", n = (t) => `${i}-${t}`, e = (t) => t.map(n).join(" ");
export {
  s as SDK_UNITS_LIST_SUFFIX,
  i as SDK_UNIT_DETAILS_SUFFIX,
  n as getSdkUnitDetailsClassName,
  e as getSdkUnitDetailsClassNames,
  a as getSdkUnitListClassName
};
//# sourceMappingURL=sdk.js.map
